import type { UploadFile } from "antd";
import AccountClosingDocumentDto, { AccountClosingDocumentType } from "../../dto/Deal/AccountClosingDocumentDto";
import { SupportedLanguages } from "../Settings/TranslationModel";

type AccountClosingDocumentModel = Omit<AccountClosingDocumentDto, "creationDate" | "date"> & {
  creationDate: Date;
  date: Date;
};

export type AccountClosingDocumentCreateType = {
  type: AccountClosingDocumentType;
  language: SupportedLanguages;
  currencyId?: number;
  fileFormat?: "DOCX" | "EXCEL" | "PDF";
};

export type AccountClosingDocumentUploadType = {
  date: Date;
  type: AccountClosingDocumentType;
  accountId: number;
  file: Pick<UploadFile, "originFileObj">;
};

export class AccountClosingDocumentDataConverter {
  static convertClosingDocument(closingDocument: AccountClosingDocumentDto): AccountClosingDocumentModel {
    return { ...closingDocument, creationDate: new Date(closingDocument.creationDate), date: new Date(closingDocument.date) };
  }

  static convertClosingDocuments(closingDocuments: Array<AccountClosingDocumentDto>): Array<AccountClosingDocumentModel> {
    return closingDocuments.map((x) => this.convertClosingDocument(x));
  }
}

export default AccountClosingDocumentModel;
